// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { HolderServiceRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Holder';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useRejectHolderServiceRequest: () => UseMutationResult<
  void,
  string,
  {
    holderServiceRequestCid: ContractId<HolderServiceRequest>;
    rejectReason: string;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['rejectRegistryHolderServiceRequest', ledgerApi],
    mutationFn: async ({ holderServiceRequestCid, rejectReason }) => {
      return ledgerApi.rejectRegistryHolderServiceRequest(holderServiceRequestCid, rejectReason);
    },
  });
};

export default useRejectHolderServiceRequest;
